import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const BasketCTAButton = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 120px;
  button {
    width: 100%;
  }

  ${media.md`
    display: none;
  `}
`;

export const BasketToolbar = styled.div`
  display: none;

  ${media.md`
    display: flex;
  `}
`;
